import React from 'react';
import propTypes from 'prop-types';
import Button from '~/Components/Global/Form/Button';
import history from '~/Providers/History';

import Card from '~/Components/Layout/Card/Card';
import Form from '~/Components/Global/Form/Form';
import TextInput from '~/Components/Global/Form/TextInput';
import { errorApi } from '~/Providers/Api';
import Store from '~/Redux/Store';
import { error } from '~/Redux/Modules/Notifications';
import GoogleSignInWrapper from '~/Components/Global/GoogleSignInWrapper/GoogleSignInWrapper';

import './Login.scss';
import Storage from '~/Providers/Storage';
import AppleSignInButton from '~/Components/Global/AppleSignInButton/AppleSignInButton';

const Login = ({
  handleLogin,
  updateField,
  current,
  isFetching,
  handleGoogleLogin,
  handleAppleLogin,
}) => {
  const search = new URLSearchParams(window.location.search);
  const redirect = search.get('redirect');

  const handleGoogleSuccess = response => {
    console.info('handleGoogleSuccess', response.code);
    handleGoogleLogin(response, redirect);
  };

  const handleGoogleFailed = err => {
    console.error('handleGoogleFailed', JSON.stringify(err.error));
    errorApi.noticeError(err, 'handleGoogleFailed');
    Store.dispatch(error('Sorry, an error occurred', err.error));
  };

  const handleAppleSuccess = response => {
    console.info('handleAppleSuccess', response);
    if (response.user) {
      console.log('found apple user', response.user);
      Storage.set('appleIdUser', JSON.stringify(response.user));
    }
    handleAppleLogin(response, redirect);
  };

  const handleAppleFailed = err => {
    console.error('handleAppleFailed', JSON.stringify(err.error));
    errorApi.noticeError(err, 'handleAppleFailed');
    Store.dispatch(error('Sorry, an error occurred', err.error));
  };

  const inAppBrowser = () => {
    return (
      window.navigator.userAgent.indexOf('FBAN') !== -1 ||
      window.navigator.userAgent.indexOf('FBAV') !== -1 ||
      window.navigator.userAgent.indexOf('Bytedance') !== -1
    );
  };

  return (
    <Card>
      <Form handleSubmit={() => handleLogin({ current }, redirect)}>
        <TextInput
          className="minimal-input mobile-font-fix"
          onChange={updateField}
          placeholder="Email address"
          name="email"
          showLabel={false}
          type="email"
          value={current.email}
        />
        <TextInput
          className="minimal-input mobile-font-fix margin-bottom"
          onChange={updateField}
          placeholder="Password"
          name="password"
          showLabel={false}
          type="password"
          value={current.password}
        />
        <div className="center margin-top">
          <Button
            type="submit"
            text="LOGIN"
            actionText="Logging In"
            isFetching={isFetching}
            disabled={isFetching}
            className="btn btn-default pill"
          />
        </div>
      </Form>
      {!window.disableSocial && (
        <>
          <br />
          {!inAppBrowser() && (
            <div className="google-login-button-wrapper">
              <GoogleSignInWrapper
                disabled={isFetching}
                actionText="Logging In"
                buttonText="Login with Google"
                onSuccess={credentialResponse => {
                  handleGoogleSuccess(credentialResponse);
                  console.log(credentialResponse);
                }}
                onError={err => {
                  handleGoogleFailed(err);
                  console.log('Login Failed');
                }}
              />
            </div>
          )}
          <div className="apple-login-button-wrapper">
            <AppleSignInButton
              disabled={isFetching}
              isFetching={isFetching}
              actionText="Logging In"
              buttonText="Login with Apple"
              onSuccess={handleAppleSuccess}
              onError={handleAppleFailed}
            />
          </div>
        </>
      )}
      <hr />
      <div className="card-caption login-link-wrapper">
        <small>Forgot your password?</small>
        <button onClick={() => history.push('/forgot-password')} className="reset-link">
          <small>RESET</small>
        </button>
      </div>
    </Card>
  );
};

Login.propTypes = {
  handleLogin: propTypes.func,
  handleGoogleLogin: propTypes.func,
  handleAppleLogin: propTypes.func,
  updateField: propTypes.func,
  current: propTypes.object,
  isFetching: propTypes.bool,
};

Login.defaultProps = {
  isAuthenticated: false,
  isFetching: false,
  hasFetched: false,
};

export default Login;
